import DL_img from '../images/stips/docs/DL.png';
import INS_img from '../images/stips/docs/INS.png';
import POI_img from '../images/stips/docs/POI.png';
import MILEAGE_img from '../images/stips/docs/MILEAGE.png';
import OLD_img from '../images/stips/docs/OLD.png';
import STIPS_img from '../images/stips/docs/STIPS.png';
import REFS_img from '../images/stips/docs/REFS.png';
import MMN_img from '../images/stips/docs/MMN.png';
import REG_img from '../images/stips/docs/REG.png';
import PYMT_img from '../images/stips/docs/PYMT.png';

import COMP_img from '../images/stips/comp.png';
import HELP_img from '../images/stips/help.png';
import PHONE_img from '../images/stips/phone.png';
import SUBMITTED_img from '../images/stips/status/submitted.png';
import VERIFIED_img from '../images/stips/status/verified.png';
import REQUESTED_img from '../images/stips/status/requested.png';
import REJECTED_img from '../images/stips/status/rejected.png';

import EQUALHOUSING_img from '../images/logos/equal-housing.png';
import NCUA_img from '../images/logos/NCUA.png';

import CARBLACK_img from '../images/icon.png';
import CARWHITE_img from '../images/car_white.png';

export const StipIcons = {
    DL1: DL_img,
    DL2: DL_img,
    DLOC: DL_img,
    GRN: DL_img,
    INS: INS_img,
    POI: POI_img,
    ODM: MILEAGE_img,
    OLD: OLD_img,
    STIPS: STIPS_img,
    EXM: MILEAGE_img,
    REF: REFS_img,
    MMN: MMN_img,
    VIN: MILEAGE_img,
    POR: STIPS_img,
    ML: STIPS_img,
    BNK: STIPS_img,
    TXRTN: STIPS_img,
    REG: REG_img,
    PYMT: PYMT_img
};

export const getStipIcon = (key) => {
    return StipIcons[key] || STIPS_img;
};

export const StipsIcons = {
    done: COMP_img,
    help: HELP_img,
    phone: PHONE_img,
    submitted: SUBMITTED_img
};

export const StipStatusIcons = {
    SUBMITTED: SUBMITTED_img,
    UNDERREVIEW: SUBMITTED_img,
    VERIFIED: VERIFIED_img,
    REQUIRED: REQUESTED_img,
    REJECTED: REJECTED_img
};

export const Logos = {
    EQUALHOUSING: EQUALHOUSING_img,
    NCUA: NCUA_img
};

export const Icons = {
    CARBLACK: CARBLACK_img,
    CARWHITE: CARWHITE_img
};